<template lang="html">
  <section class="app-create-news-type">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <form @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="newsType" class="w-25 align-self-center">* Type :</label>
        <div class="w-100">
          <input :class="$v.dataForm.newsType.$error ? 'is-invalid': ''" type="text"
                 @blur="$v.dataForm.newsType.$touch()" v-model="dataForm.newsType"
                 class="form-control" id="newsType">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.newsType.required">
              You must absolutely enter a news type !
            </div>
            <div v-if="!$v.dataForm.newsType.minLength">
              News type must not have less than {{$v.dataForm.newsType.$params.minLength.min}} characters !
            </div>
            <div v-if="!$v.dataForm.newsType.maxLength">
              News type must not contain more than {{$v.dataForm.newsType.$params.maxLength.max}} characters !
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {uuid} from 'vue-uuid'
import {mapGetters, mapActions} from "vuex";
import {FORM_NEWS_TYPES_VALIDATIONS} from '../../validations/formNewsTypes'
export default {
  name: 'CreateNewsType',
  props: [],
  mounted () {},
  created () {},
  validations: FORM_NEWS_TYPES_VALIDATIONS,
  data () {
    return {
      dataForm : {
        newsTypeId: uuid.v4(),
        newsType: undefined
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'createData'
    ]),
    onSubmit () {
      const formData = {
        news_type_id: this.dataForm.newsTypeId,
        type: this.dataForm.newsType
      };
      this.dataForm.newsTypeId = uuid.v4();
      this.createData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => {
            this.messageSubmission = '';
            this.resetForm();
          }, 5000);
        })
        .catch(data => console.log(data))
    },
    resetForm () {
      this.dataForm.newsTypeId = uuid.v4();
      this.dataForm.newsType = undefined;
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
  .app-create-news-type {}
</style>



// WEBPACK FOOTER //
// src/components/news_types/CreateNewsType.vue